"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _chipModule = _interopRequireDefault(require("./sass/chip.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Chip = function Chip(_ref) {
  var _chipClasses;

  var className = _ref.className,
      clickClose = _ref.clickClose,
      data = _ref.data,
      display = _ref.display;
  var closeChip = (0, _react.useCallback)(function () {
    return clickClose(data);
  });
  var chipClasses = (_chipClasses = {
    'default': className === 'default'
  }, _defineProperty(_chipClasses, _chipModule.default.container, true), _defineProperty(_chipClasses, className, className), _chipClasses);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(chipClasses)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _chipModule.default.text
  }, data[display]), /*#__PURE__*/_react.default.createElement("div", {
    onClick: closeChip,
    className: _chipModule.default.clossing_tag,
    "data-testid": "closeChip"
  }, "\u2715"));
};

Chip.defaultProps = {
  className: 'default',
  clickClose: function clickClose() {},
  data: ['tag01'],
  display: 0
};
Chip.propTypes = {
  className: _propTypes.default.string,
  clickClose: _propTypes.default.func,
  data: _propTypes.default.array,
  display: _propTypes.default.number
};
var _default = Chip;
exports.default = _default;